import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { style: {"min-width":"300px"} }, {
    default: _withCtx(() => [
      (_ctx.error)
        ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_q_banner, { class: "text-white bg-negative" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.error), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_card_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_form, {
            onSubmit: _ctx.onSubmit,
            class: "q-gutter-md"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_input, {
                rules: [
            val => val.length > 0 || 'Channel cannot be empty',
            val => val.length <= 25 || 'Channel name must have 25 or less characters',
          ],
                modelValue: _ctx.channelName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.channelName) = $event)),
                label: "Channel name",
                "lazy-rules": "",
                autofocus: ""
              }, null, 8, ["rules", "modelValue"]),
              _createVNode(_component_q_btn, {
                label: "Add channel",
                color: "primary",
                type: "submit",
                loading: _ctx.loading
              }, null, 8, ["loading"])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}